import { Bot } from "lucide-react";

interface AgentChatAvatarProps {
  avatarUrl?: string | null;
  name?: string;
  size?: "sm" | "md";
}

function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
}

export function AgentChatAvatar({ avatarUrl, name, size = "sm" }: AgentChatAvatarProps) {
  const px = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const textSize = size === "sm" ? "text-[10px]" : "text-xs";

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name || "Agent"}
        className={`${px} shrink-0 rounded-full object-cover`}
      />
    );
  }

  if (name) {
    return (
      <div
        className={`flex ${px} shrink-0 items-center justify-center rounded-full bg-accent/15 ${textSize} font-semibold text-accent`}
      >
        {getInitials(name)}
      </div>
    );
  }

  return (
    <div className={`flex ${px} shrink-0 items-center justify-center rounded-full bg-accent/10`}>
      <Bot size={size === "sm" ? 14 : 16} className="text-accent" />
    </div>
  );
}
